import { db } from "@/plugins/firebase";
import { ICast } from "@/types/cast";
import { collection, query, where, getDocs, DocumentData, orderBy, startAt } from "firebase/firestore";
export const getCastList = async (): Promise<ICast[]> => {

    const q = query(collection(db, "mullion/v1/casts"), where('isDeleted', '==', false), where('isApproval', '==', true))
    const snapshot = await getDocs(q);
    const castList: DocumentData[] = [];
    snapshot.forEach((doc) => {
        const data = doc.data();
        if (data["name"]) {
            data["uid"] = doc.id;
            castList.push(data);
        }
    })
    return castList as ICast[];
}

export const getNewComerList = async(): Promise<ICast[]> =>{
    const newComerDate = new Date(Date.now() - 30 * 24 * 60 * 60 * 1000);
    const q = query(collection(db, "mullion/v1/casts"), where('isDeleted', '==', false), where('isApproval', '==', true), orderBy('createdAt', 'asc'), startAt(newComerDate))
    const snapshot = await getDocs(q);
    const castList: DocumentData[] = [];
    snapshot.forEach((doc) => {
        const data = doc.data();
        if (data["name"]) {
            data["uid"] = doc.id;
            castList.push(data);
        }
    })
    return castList as ICast[];
}